// extracted by mini-css-extract-plugin
module.exports = {"recentSearchDashboard":"recent-search-box_recentSearchDashboard__j8oUz","small":"recent-search-box_small__lHWWM"};